import { Component } from '@angular/core';
import { EduIconComponent, Icons } from '@atoms/icon/icon.component';
import { environment } from '@environments/environment';
import { SharedCommonModule } from '@shared/common.module';

@Component({
  selector: 'edu-beta-banner',
  templateUrl: './beta-banner.component.html',
  imports: [SharedCommonModule, EduIconComponent],
})
export class BetaBannerComponent {
  public legacyDashboardUrl = environment.legacyDashboardUrl;
  public BetaIcon = Icons.BETA;
}
